<template>
  <div class="page-content">
    <el-drawer
    :append-to-body="true"
      class="drawer"
      title="选择设备"
      size="40%"
      :visible.sync="drawerFlag"
      :before-close="handleClose">
      <div class="content">
        <el-row class="screen" :span="24" style="margin-bottom:20px">
          <!-- <el-col :span="8">
            <el-select v-model="drawerSelectVal" placeholder="请选择" class="sel" style="width: 100%">
              <el-option
                v-for="item in options"
                :key="item.optionsKey"
                :label="item.productName"
                :value="item.productKey">
              </el-option>
            </el-select>
          </el-col> -->
          <el-col :span="16">
            <el-input placeholder="请输入设备名" v-model.trim="deviceNameInputVal" @keyup.13.native="drawerHandlerKeyUp" class="inp" style="width: 100%">
              <el-button slot="append" icon="el-icon-search" @click="drawerDemand"></el-button>
            </el-input>
          </el-col>
        </el-row>
         <el-table
          @selection-change="handleSelectionChange"
          :row-key="getRowKeys"
          ref="multipleTable"
          :data="tableData"
          tooltip-effect="dark"
          style="width: 100%"
          :header-cell-style="{background:'#eef1f6',color:'#606266'}"
          >
          <el-table-column
          :reserve-selection="true"
            type="selection">
          </el-table-column>
          <el-table-column
            prop="deviceName"
            label="设备名称"
            >
            <!-- <template slot-scope="scope">{{ scope.row.date }}</template> -->
          </el-table-column>
           <el-table-column
            prop="productName"
            label="设备所属产品"
            >
            <!-- <template slot-scope="scope">{{ scope.row.date }}</template> -->
          </el-table-column>
          <!-- <el-table-column
            prop="version"
            label="操作"
            show-overflow-tooltip>
            <template slot-scope="scope">
              <el-button
                size="mini"
                @click="choose(scope.row)">选择</el-button>
            </template>
          </el-table-column> -->
        </el-table>
        <!-- 分页管理 -->
      <el-row
        v-show="!listLoading"
        class="pagination-container"
        type="flex" justify="end"
        style="margin-top:10px"
        >
        <!-- 页码按钮的数量currenCurrent  sizeChange -->
          <Paging
          :total="total"
          pagingStatus="short"
          @changePage="handleCurrentChange"/>
      </el-row>
      </div>

      <div class="drawer-footer">
        <div class="drawer-btn">
          <el-button
          type="primary"
          @click="confirm"
          >
            确定
          </el-button>
           <el-button
          @click="close"
          >
            关闭
          </el-button>
        </div>
      </div>
    </el-drawer>
  </div>
</template>
<script>
import { deviceList } from '@/api/deviceManagement'
import Paging from '@/components/paging'
export default {
  props: {
    drawerFlag: {
      type: Boolean
    },
    productKey: {
      type: String
    },
    form: {
      type: Object
    },
    multipleSelected: {
      type: Array
    }
  },
  components: {
    Paging
  },
  data () {
    return {
      deviceNameInputVal: '', // 抽屉组件inputVal
      listQuery: {
        page: 1,
        limit: 10
      },
      total: 0,
      listLoading: false, // 根据loading来进行显示/隐藏
      tableData: [],
      multipleSelection: []
    }
  },
  created () {
    this.$nextTick(() => {
      for (let i = 0; i < this.multipleSelected.length; i++) {
        this.$refs.multipleTable.toggleRowSelection(this.multipleSelected[i])
      }
    })
    this.getDeviceList()
  },
  methods: {
    confirm () {
      const deviceList = []
      const deviceName = []
      this.multipleSelection.forEach(item => {
        deviceList.push({ label: item.deviceName, value: item.deviceId })
        deviceName.push(item.deviceId)
      })
      // 让父组件去更改，才能引起再次验证
      this.$emit('updateDevice', {
        deviceList: deviceList,
        deviceName: deviceName,
        selected: this.multipleSelection
      })
      this.handleClose()
      console.log(this.multipleSelection)
    },
    handleSelectionChange (val) {
      console.log('勾选改变：', val)
      this.multipleSelection = val
    },
    getRowKeys (row) {
      return row.deviceId
    },
    choose (row) {
      console.log('row:', row)
      console.log('this.form:', this.form)
      const deviceList = [{
        label: row.deviceName,
        value: row.deviceId
      }]
      const deviceName = [row.deviceId]
      // 让父组件去更改，才能引起再次验证
      this.$emit('updateDevice', {
        deviceList: deviceList,
        deviceName: deviceName
      })
    },
    // 改变页码
    handleCurrentChange (val) {
      Object.assign(this.listQuery, val)
      this.getDeviceList()
    },
    // 搜索
    drawerDemand () {
      this.getDeviceList('search')
    },
    // 抽屉搜索功能
    drawerHandlerKeyUp (e) {
      if (e.keyCode === 13) {
        this.getDeviceList('search')
      }
    },
    // 关闭抽屉
    handleClose (done) {
      this.focusStatus = false
      // this.$emit('blur')
      this.$emit('closeDrawer')
      // this.$confirm('确认关闭？')
      //   .then(_ => {
      //     this.$emit('closeDrawer')
      //   })
      //   .catch(_ => {})
      //   .finally(_ => {
      //     this.$emit('blur')
      //   })
    },
    close () {
      this.$emit('updateDevice', {
        deviceList: [],
        deviceName: '',
        selected: []
      })
      this.$emit('closeDrawer')
    },
    getDeviceList (isSearch) {
      const params = {
        deviceStatus: '',
        listType: 0, // 表示获取全部设备
        pageNumber: this.listQuery.page,
        pageSize: this.listQuery.limit,
        productKey: this.productKey
      }

      if (isSearch === 'search') {
        console.log('this.deviceNameInputVal:', this.deviceNameInputVal)
        console.log('flag:', this.deviceSeachType === 'deviceName')
        if (!this.deviceNameInputVal) {
          this.$message({
            type: 'info',
            message: '请先输入设备名称'
          })
          return
        }
        params.deviceName = this.deviceNameInputVal
      }
      deviceList(params)
        .then(res => {
          res = res.data
          if (res.data.data) {
            const list = res.data.data
            this.total = res.data.total
            this.tableData = []
            this.tableData = list
          } else {
            this.total = res.data.total
            this.tableData = []
          }
        })
    }
  }
}
</script>
<style lang="less" scope>
  .drawer{
      /deep/ .el-drawer__header{
        line-height: 60px !important;
        font-size: 18px !important;
        height: 60px !important;
        border-bottom: 1px solid #efefef !important;
        padding: 0 24px !important;
        margin-bottom: 0 !important;
      }
      .el-drawer__body{
        margin: 10px 20px;
        display: flex;
        flex-direction: column;
        .content{
          // margin: 16px 24px 0 24px;
          .screen{
            display: flex;
            /deep/ .el-input{
              margin-left: 0;
              width: 90%;
            }
          }
          /deep/ .el-table::before{
            background: white;
          }
          /deep/ .el-table th>.cell:first-child{
            padding: 0 14px
          }

        }
        .drawer-footer{
          display: flex;
          justify-content: space-between;
          align-items: center;
          border-top: 1px solid #ececec;
          margin-top: 10px;
          padding: 0 24px ;
          height:64px;
          i{
            color: #409eff;
            font-style: normal;
          }
        }
      }
      /deep/ :focus {
        outline: 0;
      }
    }
</style>
